/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".example-radio-group[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin:15px 0}.example-radio-button[_ngcontent-%COMP%]{margin:5px}"];
export { styles as styles };
